export enum AccountUserType {
  Customer = 'Customer',
  Staff = 'Staff',
  Partner = 'Partner',
}
